import { uniqWith } from "lodash-es";
import { useMemo } from "react";

import type { SegmentWithMoments } from "../../../server/supabase-segment-service";
import type { SegmentRowWithOptions } from "../types";

const rowOptions = { preventEditing: false, preventDeletion: false, preventEditingReason: "N/A" };

export function useProcessedSegments(
  segments: SegmentWithMoments[],
  showArchived?: boolean,
): SegmentRowWithOptions[] {
  return useMemo(
    () =>
      uniqWith(segments, (currentVal, otherVal) => currentVal.id === otherVal.id)
        .map((datum) => ({
          ...datum,
          id: datum.id!,
          moments: datum.moments ?? [],
          options: rowOptions,
        }))
        .filter((datum) =>
          showArchived ? !datum.is_default : !datum.is_default && datum.deleted_at === null,
        )
        .filter(({ name, moments }) => Boolean(name) || moments?.length === 1),
    [segments, showArchived],
  );
}
